import React, { useContext } from "react"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import AppContext from "../../context/AppContext"

/* Styled Components */
const ModalBG = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
`

const Modal = styled.div`
  background: #fff;
  padding: 80px;
  width: 982px;
  height: auto;
  position: absolute;
  display: flex;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  h2 {
    color: ${props => props.theme.primaryTextColor};
    font-family: ${props => props.theme.secondaryFont};
    font-size: 48px;
    font-weight: bold;
    line-height: 56px;
    margin-bottom: 0;
    text-transform: capitalize;
  }

  h3 {
    color: ${props => props.theme.primaryTextColor};
    font-family: ${props => props.theme.secondaryFont};
    font-size: 28px;
    font-weight: 500;
    line-height: 32px;
  }

  p {
    color: ${props => props.theme.primaryTextColor};
    font-family: ${props => props.theme.primaryFont};
    font-size: 18px;
    line-height: 28px;
  }

  > div:nth-child(1) {
    width: 600px;
  }

  > div:nth-child(2) {
    margin-left: auto;
    width: 200px;
    @media (max-width: ${props => props.theme.mediumBreakpoint}) {
      margin-left: 50px;
      min-width: 200px !important;
    }
  }

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    width: 95%;
    padding: 40px;
  }

  @media (max-width: ${props => props.theme.smallBreakpoint}) {
    flex-direction: column-reverse;
    padding: 20px;

    h2 {
      font-size: 32px;
    }

    > div:nth-child(1) {
      width: 100%;
    }

    img {
      max-width: 50%;
    }

    > div:nth-child(2) {
      display: flex;
      width: 100%;
      min-width: 100%;
      margin-left: 0;
      align-items: center;

      > img {
        flex-shrink: 1;
      }
    }
  }

  @media (max-width: ${props => props.theme.extraSmallBreakpoint}) {
    > div:nth-child(2) {
      justify-content: space-around;
    }
  }
`

const Redeem = styled.h5`
  color: ${props => props.theme.primaryTextColor};
  font-family: ${props => props.theme.secondaryFont};
  font-size: 28px;
  font-weight: 500;
  line-height: 32px;
  text-align: center;
  margin-bottom: 0;
  margin-top: 0;
`

const Points = styled.h4`
  color: ${props => props.theme.primaryColor};
  font-family: ${props => props.theme.secondaryFont};
  font-size: 44px;
  font-weight: bold;
  line-height: 48px;
  text-align: center;
  margin-top: 0;

  @media (max-width: ${props => props.theme.smallBreakpoint}) {
    font-size: 32px;
  }
`

const Close = styled.span`
  position: absolute;
  right: 20px;
  top: 20px;
  font-size: 1.5rem;
  font-family: ${props => props.theme.primaryFont};
  font-weight: bold;
  cursor: pointer;
  color: ${props => props.theme.primaryColor};
`

const ButtonLink = styled.span`
  cursor: pointer;
  color: #fffefc;
  font-family: ${props => props.theme.primaryFont};
  font-size: 18px;
  font-weight: 900;
  line-height: 24px;
  text-align: center;
  text-decoration: none;
  background: ${props => props.theme.primaryColor};
  padding: 10px 50px;
  display: inline-block;
  border: solid 2px ${props => props.theme.primaryColor};
  cursor: pointer;

  &:hover {
    background: #c43745;
    border-color: #c43745;
  }
`
const AddToCart = styled(ButtonLink)`
  position: relative;
  width: 235px;

  & svg {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translate(0, -50%);
  }
`
/* End Styled Components */

const ProductModal = props => {
  return (
    <AppContext.Consumer>
      {appContext => (
        <ModalBG>
          <Modal>
            <div>
              <h2>{props.product.name}</h2>
              <div
                dangerouslySetInnerHTML={{ __html: props.product.description }}
              />
              <AddToCart
                onClick={() => {
                  appContext.changeCart([
                    ...appContext.state.cart,
                    props.product.id,
                  ])
                  props.onClick(false)
                }}
              >
                <FontAwesomeIcon icon="shopping-cart" />
                Add to Cart
              </AddToCart>
            </div>
            <div>
              <img
                src={
                  props.product.img_url ||
                  "http://prang.flywheelsites.com/wp-content/uploads/2019/04/33FF1E9E-1E4F-395D-A3A19C64CE47B038-300x300.jpg"
                }
                alt=""
              />
              <div>
                <Redeem>Redeem</Redeem>
                <Points>{props.product.points} Points</Points>
              </div>
            </div>
            <Close onClick={() => props.onClick(false)}>
              <FontAwesomeIcon icon="times" />
            </Close>
          </Modal>
        </ModalBG>
      )}
    </AppContext.Consumer>
  )
}

export default ProductModal
